/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Tournament not found" |
*
* @param {Tournament_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_not_found = /** @type {((inputs?: Tournament_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi introuvable")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo no encontrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio não encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo non trovato")
	return /** @type {LocalizedString} */ ("Tournament not found")
});